import React from 'react';
import * as R from 'ramda';
import axios from 'axios';

import { ErplyAttributes } from 'utils';

import {
  assertCartSatisfiesTaxRates,
  TaxRateValidatingBillRow,
  TaxRateValidationTable,
} from '../../components/TaxRateValidation';
import { getEFSTAEndpoint } from '../../API/selectors';
import { FiscalIntegration } from '../FiscalIntegration';
import { HeaderIcon } from '../../components/HeaderIcon';

import { getCurrentTransaction } from './getCurrentTransaction';
import { TraC } from './ATRequestType';
import { EFSTAATTaxRates } from './constants';

const ATTRIBUTES = {
  code: 'EFSTA-AT-CODE',
  link: 'EFSTA-AT-LINK',
};

const efr = axios.create();

efr.interceptors.response.use(
  f => f,
  err => {
    try {
      const warning = err.data.TraC.Result.Warning;
      if (warning) throw new Error(warning);
    } catch (e) {
      throw err;
    }
  },
);

export const ATFiscalIntegration: FiscalIntegration = {
  getStatus: () => ({
    type: 'valid',
    message: 'Selected: AT',
  }),
  ComponentConfiguration: () => {
    return <TaxRateValidationTable efstaRates={EFSTAATTaxRates} />;
  },
  ComponentHeader: () => {
    return <HeaderIcon country="AT" />;
  },
  onSaveDocument: requests => async (dispatch, getState) => {
    const transaction = getCurrentTransaction(getState());
    efr.defaults.baseURL = getEFSTAEndpoint(getState());

    const reqsWithPromises = R.map(
      R.when(R.propEq('requestName', 'saveSalesDocument'), async sdoc => {
        const attrs = ErplyAttributes.fromFlatArray(sdoc);
        const sdocNoAttrs = ErplyAttributes.withoutFlatArray(sdoc);

        const res = await efr.post<TraC>('/register', { Tra: transaction });
        const { Code, Link } = res.data.TraC?.Fis ?? {};

        if (!Code) throw new Error('EFSTA failed to returned proper code');
        if (!Link) throw new Error('EFSTA failed to return proper link');

        attrs.set(ATTRIBUTES.code, Code);
        attrs.set(ATTRIBUTES.link, Link);
        return R.mergeDeepRight(sdocNoAttrs, attrs.asFlatArray);
      }),
    )(requests) as typeof requests;

    return Promise.all(reqsWithPromises).catch(err => {
      throw new Error(
        'EFSTA AT failed to save salesDocument. Ensure the microservice is running and EFSTA is configured',
        { cause: err },
      );
    });
  },
  onOpenPaymentModal: (p, ap) => async (dispatch, getState) => {
    await dispatch(
      assertCartSatisfiesTaxRates(EFSTAATTaxRates.map(rate => rate.group)),
    );
    return ap;
  },
  UICustomTableBillRow: ({ order, children }) => {
    const codes = EFSTAATTaxRates.map(rate => rate.group);
    return (
      <TaxRateValidatingBillRow order={order} allowedCodes={codes}>
        {children}
      </TaxRateValidatingBillRow>
    );
  },
};
